// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"7012bbeb","453":"fc7c4cb3"}[chunkId] + ".chunk.js";
};